
function initLightBox(){

}

export {
    initLightBox
}